module.exports = __webpack_public_path__ + "media/components/src/assets/images/caution/caution-c78c4c8ac4c8ec21b6b6e0bd987a2eeb.svg";